import { render, staticRenderFns } from "./FileDownloads.vue?vue&type=template&id=8436b8e2&"
import script from "./FileDownloads.vue?vue&type=script&lang=js&"
export * from "./FileDownloads.vue?vue&type=script&lang=js&"
import style0 from "./FileDownloads.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports